import LinkIcon from "@src/app/assets/icons/link.svg?react";
import TickIcon from "@src/app/assets/icons/tick.svg?react";
import Button from "@src/app/components/Button/Button";
import viewportState from "@src/app/stores/viewport";
import cx from "classnames";
import { type ReactElement } from "react";

interface Props {
  iconOnly?: boolean;
  isVideoArticle?: boolean;
  articleUrl?: string;
  setHasCopiedLink: (value: boolean) => void;
  hasCopiedLink: boolean;
  statusMessagePosition?: "left" | "right";
}

export default function CopyLinkButton({
  iconOnly,
  isVideoArticle,
  articleUrl,
  setHasCopiedLink,
  hasCopiedLink,
  statusMessagePosition = "right",
}: Props): ReactElement {
  // const [hasCopiedLink, setHasCopiedLink] = useState(false);
  const { isMobileView, isMobileOrTabletDevice } = viewportState;
  const currentUrl = isVideoArticle
    ? (articleUrl ?? "")
    : typeof window !== "undefined"
      ? window.location.href
      : "";

  const copyLink = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        setHasCopiedLink(true);
      })
      .catch((err) => {
        console.error("Failed to copy URL:", err);
      });

    setTimeout(() => {
      setHasCopiedLink(false);
    }, 3000);
  };

  return (
    <div id="copy-link-button" className="relative">
      <Button
        variant="tertiary"
        size="medium"
        icon={<LinkIcon width={20} height={20} />}
        onClick={copyLink}
      >
        {!iconOnly && <span>链接</span>}
      </Button>

      {hasCopiedLink && (
        <div
          style={
            isMobileView && isMobileOrTabletDevice
              ? {
                  bottom: `calc(env(safe-area-inset-bottom) + 20px)`,
                  left: "20px",
                  right: "20px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }
              : isMobileOrTabletDevice
                ? {
                    bottom: `calc(env(safe-area-inset-bottom) + 20px)`,
                    left: "20px",
                    width: "319px",
                  }
                : {}
          }
          className={cx(
            // Base styles
            "z-[100] flex items-center flex-nowrap gap-[10px] p-2 pr-4 bg-white text-button-secondary-label text-xs xl:text-body-2 font-semibold shadow-md rounded-[4px]",

            // Animation
            "animate-fade-in-up",
            {
              // Mobile & Tablet Device Postion
              fixed: isMobileOrTabletDevice,

              // Desktop only Position
              "absolute w-max": !isMobileOrTabletDevice,

              // Desktop toast positions

              "-top-2 left-10":
                iconOnly &&
                statusMessagePosition === "right" &&
                !isMobileOrTabletDevice,
              "-top-2 right-10":
                iconOnly &&
                statusMessagePosition === "left" &&
                !isMobileOrTabletDevice,

              // Desktop full toast
              "bottom-11 right-0 animate-fade-in-up":
                !iconOnly && !isMobileOrTabletDevice,
            },
          )}
        >
          <TickIcon className="m-[6px] mr-0" width={20} height={20} />
          <span className="font-semibold">链接已复制</span>
        </div>
      )}
    </div>
  );
}
